import React from 'react';
import { SvgIcon } from '@material-ui/core'

const PersonalPhysician = (props) => (
  <SvgIcon
    viewBox="0 0 31.927 36.505"
    {...props}
  >
    <path 
      d="M362.749,277.122A9.126,9.126,0,1,0,353.623,268,9.126,9.126,0,0,0,362.749,277.122Zm0-15.971A6.845,6.845,0,1,1,355.9,268,6.856,6.856,0,0,1,362.749,261.151Zm6.681,18.26c-2.41-.071-3.158,1.134-6.681,1.134s-4.263-1.2-6.673-1.134a9.577,9.577,0,0,0-9.3,9.575V294.8a.571.571,0,0,0,.57.57h1.141a.572.572,0,0,0,.57-.57v-5.818a7.294,7.294,0,0,1,6.845-7.258v5.825a3.993,3.993,0,1,0,2.281,0V282.07a14.277,14.277,0,0,0,9.127,0v4.906a4.744,4.744,0,0,0-3.422,4.606v2.082a1.144,1.144,0,0,0,.335.806l.734.734a.573.573,0,0,0,.806,0l.806-.806a.571.571,0,0,0,0-.806l-.406-.406v-1.8a2.291,2.291,0,0,1,2.667-2.253,2.374,2.374,0,0,1,1.9,2.375v1.682l-.406.406a.573.573,0,0,0,0,.806l.806.806a.573.573,0,0,0,.806,0l.734-.734a1.144,1.144,0,0,0,.335-.806v-2.282a4.548,4.548,0,0,0-3.422-4.391v-5.255a7.293,7.293,0,0,1,6.844,7.258V294.8a.572.572,0,0,0,.57.57h1.141a.572.572,0,0,0,.57-.57v-5.818a9.555,9.555,0,0,0-9.276-9.575Zm-10.674,11.971a1.711,1.711,0,1,1-1.711-1.711A1.716,1.716,0,0,1,358.756,291.381Z" 
      transform="translate(-346.779 -258.869)"
    />
  </SvgIcon>
);

export default PersonalPhysician;